<template>
  <div :style="iconStyle" class="icon">
    <template v-if="type === 'solid'">
      <svg-vue :icon="name" :fill="color" :style="iconStyle" />
    </template>
    <template v-else>
      <svg-vue :icon="name" :stroke="color" :style="iconStyle" />
    </template>
  </div>
</template>

<script>
import { toRefs, computed } from '@vue/composition-api';

export default {
  name: 'IconComponent',

  props: {
    name: {
      type: String,
      required: true,
    },

    size: {
      type: Number,
      default: 24,
    },

    height: {
      type: Number,
    },

    color: {
      type: String,
      default: 'black',
    },

    type: {
      type: String,
      default: 'solid',
    },
  },

  setup(props) {
    const { size, height } = toRefs(props);

    const iconStyle = computed(() => ({
      width: `${size.value}px`,
      height: `${(height.value ?? size.value)}px`,
    }));

    return { iconStyle };
  },
};
</script>

<style lang="postcss" scoped>
.icon {
  @apply block;
}
</style>
